import * as actionTypes from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} IsVisibleState */

/** @type {IsVisibleState} */
const initialState = false;

const set = () => true;
const reset = () => false;

export default createReducer(initialState, {
  [actionTypes.IMPORT_WORKS_INTO_INTERVENTION_SUCCESS]: reset,
  [actionTypes.OPEN_WORK_ORDER_MODAL]: set,
  [actionTypes.CLOSE_WORK_ORDER_MODAL]: reset,
  [actionTypes.FETCH_WORKS_ORDER_SUCCESS]: set,
  [LOCATION_CHANGE]: reset,
});
